export default __webpack_public_path__ + "static/media/li.572f9027.svg";